export default {
  title: 'Criar Link de Onboarding',
  steps: {
    select_gateway: 'Selecionar Gateway',
    copy_link: 'Copiar Link',
  },
  select_gateway: {
    description: 'Escolha o gateway de pagamento para o qual pretende gerar um link de onboarding de longa duração.',
  },
  link: {
    proxy_url_label: 'URL de Onboarding',
    expires_label: 'Expira',
    copy_button: 'Copiar URL',
    copied: 'Copiado!',
    description:
      'Partilhe este URL com o comerciante. Redireciona para a página de onboarding do gateway e é válido até à data de expiração.',
  },
  buttons: {
    next: 'Seguinte',
    back: 'Voltar',
    done: 'Concluído',
  },
  toasts: {
    create_success: 'Link de onboarding criado com sucesso.',
    create_failed: 'Falha ao criar link de onboarding.',
  },
};
